<template>
  <tr>
    <td :colspan="colspan">
      <slot name="no-data">
        <div class="d-flex align-center h-30px">
          <p class="my-0 mx-2 caption text-gray-400">{{ text }}</p>
        </div>
      </slot>
    </td>
  </tr>
</template>

<script>
import Mixin from "./Mixin"

export default {
  name: "NoData",
  mixins: [Mixin],
  props: ["text"]
}
</script>

<style scoped>
tr td {
  border-top: 1px solid #e1dfdf;
}
.h-30px {
  height: 30px;
}
</style>
